// ============================================================================
// member-filters — filtres purs onglet Membres (P-ADM-14, GEST-ADMIN-IA volet 2)
// ============================================================================

export type MemberStatusFilter = 'active' | 'inactive' | 'all';

const STATUS_VALUES: readonly MemberStatusFilter[] = ['active', 'inactive', 'all'];

/** Parse ?status= depuis l'URL ; defaut = actif (masque les inactifs). */
export function parseMemberStatusFilter(raw: string | null): MemberStatusFilter {
  return STATUS_VALUES.includes(raw as MemberStatusFilter) ? (raw as MemberStatusFilter) : 'active';
}

export function filterMembersByStatus<T extends { isEmployed: boolean }>(
  members: readonly T[],
  status: MemberStatusFilter,
): T[] {
  if (status === 'all') return [...members];
  if (status === 'active') return members.filter((m) => m.isEmployed);
  return members.filter((m) => !m.isEmployed);
}

const norm = (s: string): string => s.toLowerCase().trim();

export function filterMembersBySearch<T extends { fullName: string | null; email: string; matricule: string | null }>(
  members: readonly T[],
  search: string,
): T[] {
  const q = norm(search);
  if (!q) return [...members];
  return members.filter((m) =>
    norm(`${m.fullName ?? ''} ${m.email} ${m.matricule ?? ''}`).includes(q),
  );
}
